/* 
superFetch.js allows us to send the token via a fetch call without rewriting all the header code.
*/
import Nprogress from 'nprogress';
import { jwtConfig } from '../settings';

const customHeader = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  Authorization: 'Bearer ' + localStorage.getItem('id_token') || undefined,
});

const noAuthHeader = () => ({ 'Content-Type': 'application/json' });

const base = async (method, url, data = {}, authHeader = true) => {
  let headers;
  if (authHeader) {
    headers = customHeader();
  } else {
    headers = noAuthHeader();
  }

  // we need to strip the body completely for GET requests, .net core api hates it
  let requestOptions = {};
  if (method === 'get') {
    requestOptions = {
      method,
      headers: headers,
    };
  } else {
    requestOptions = {
      method,
      headers: headers,
      body: JSON.stringify(data),
    };
    Nprogress.start();
  }

  return fetch(`${jwtConfig.fetchUrl}${url}`, requestOptions)
    .then(response => response.json())
    .then(res => res)
    .then(Nprogress.done())
    .catch(error => ({ error: 'Server Error' }));
};

const SuperFetch = {};
['get', 'post', 'put', 'delete'].forEach(method => {
  SuperFetch[method] = base.bind(null, method);
});
export default SuperFetch;
